import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from '@chakra-ui/react';
import { sansFontFamily } from '@client/theme';
export const AppError = (props) => (_jsxs(Alert.Root, { status: "error", fontFamily: sansFontFamily, children: [_jsx(Alert.Indicator, {}), _jsxs(Alert.Content, { children: [_jsx(Alert.Title, { children: props.title }), props.content && (_jsx(Alert.Description, { children: props.content }))] })] }));
